import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { YtbService } from './ytb.service';
import { SocketService } from './socket.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SearchService } from './search.service';
import { suggestions } from './video-suggestions';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less', './loader.less'],
})
export class AppComponent {
  title = 'Captionz';

  videoUrlCtrl = new FormControl();
  invalidUrl = false;
  isSearching = false;
  searchText = '';
  searchResults = [];
  inFullscreen = false;
  embededMode = (() => {
    try {
      if (window.top !== window.self) {
        return ![
          '/captionz',
          '/cats-love-youtube',
          '/captionz/',
          '/cats-love-youtube/',
        ].includes(window.top.location.pathname);
      }
    } catch (error) {
      return true;
    }
  })();
  isInDictionariez = location.search.includes('NO_REDIRECT=true');

  bullets = [];
  suggestions = suggestions;
  indexInList = -1;
  isLoadingPopularVideos = false;

  availableVoiceLanguages = [
    { code: '', name: 'All spoken languages', en: '' },
    { code: 'en', name: 'English', en: 'English' },
    { code: 'sv', name: 'Svenska', en: 'Swedish' },
    { code: 'es', name: 'Español', en: 'Spanish' },
    { code: 'fr', name: 'Français', en: 'French' },
    { code: 'de', name: 'Deutsch', en: 'German' },
    { code: 'nl', name: 'Dutch', en: 'Dutch' },
    { code: 'it', name: 'Italiano', en: 'Italian' },
    { code: 'pt', name: 'Português', en: 'Portuguese' },
    { code: 'ru', name: 'Русский', en: 'Russian' },
    { code: 'zh', name: '中文', en: 'Chinese' },
    { code: 'ja', name: '日本語', en: 'Japanese' },
    { code: 'ko', name: '한국어', en: 'Korean' },
    { code: 'ar', name: 'العربية', en: 'Arabic' },
    { code: 'hi', name: 'हिन्दी', en: 'Hindi' },
    { code: 'vi', name: 'Tiếng Việt', en: 'Vietnamese' },
    { code: 'tr', name: 'Türkçe', en: 'Turkish' },
    { code: 'id', name: 'Bahasa Indonesia', en: 'Indonesian' },
  ];

  selectedVoiceLanguage = '';

  languageSearchFn = (term: string, item: any) => {
    term = term.toLowerCase();
    return (
      item.name.toLowerCase().includes(term) ||
      (item.en && item.en.toLowerCase().includes(term))
    );
  };
  isSearchEngineBot(): boolean {
    const ua = navigator.userAgent.toLowerCase();
    // Add more bots as needed
    return /googlebot|bingbot|slurp|duckduckbot|baiduspider|yandexbot|sogou|exabot|facebot|ia_archiver/.test(
      ua
    );
  }

  constructor(
    private ytb: YtbService,
    private socketService: SocketService,
    private searchService: SearchService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    const parseParams = (search: string) => {
      const parameters = new URLSearchParams(search);
      const link = parameters.get('link');
      if (link) {
        this.ytb.playLink = link;
        return this.ytb.parseUrl(link.trim());
      } else {
        const videoId = parameters.get('v');
        const playlistId = parameters.get('list');
        const indexInPlaylist = parseInt(parameters.get('index')) - 1;
        this.searchText = parameters.get('search') || '';
        return { playlistId, indexInPlaylist, videoId };
      }
    };

    const parsed = parseParams(window.location.search);
    if (!this.ytb.saveLast(parsed)) {
      try {
        const parsedTop = parseParams(window.top.location.search);
        // console.log('Parsed params from top window url: ', parsedTop);
        this.ytb.saveLast(parsedTop);
      } catch (error) {
        // iframe is in another domain;
        console.warn(error);
      }
    }

    if (
      window.self === window.top &&
      location.hostname !== 'localhost' &&
      !location.hostname.startsWith('172') &&
      !this.isInDictionariez &&
      !this.isSearchEngineBot()
    ) {
      // not in iframe
      location.replace('/captionz');
    }

    // parse voice language from URL and localStorage
    this.selectedVoiceLanguage = new URL(
      window.top.location.href
    ).searchParams.get('voice');

    if (!this.selectedVoiceLanguage) {
      // try to get from localStorage
      this.selectedVoiceLanguage = localStorage.getItem(
        'selectedVoiceLanguage'
      );
    }
    // validate the selected voice language
    const validLanguage = this.availableVoiceLanguages.find(
      (l) =>
        l.code === this.selectedVoiceLanguage ||
        l.name === this.selectedVoiceLanguage ||
        l.en === this.selectedVoiceLanguage
    );
    this.selectedVoiceLanguage = validLanguage?.en || '';

    // if (
    //   window.self === window.top &&
    //   location.search.includes('NO_REDIRECT=true')
    // ) {
    //   // load google adsense;
    //   const s = document.createElement('script');
    //   s.setAttribute(
    //     'src',
    //     'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2864332621597639'
    //   );
    //   s.setAttribute('async', 'true');
    //   s.setAttribute('crossorigin', 'anonymous');
    //   document.head.appendChild(s);
    // }
  }

  ngOnInit() {
    this.videoUrlCtrl.valueChanges
      .pipe(
        debounceTime(this.isInDictionariez ? 800 : 4000),
        distinctUntilChanged()
      )
      .subscribe((url: string) => {
        if (url === this.searchText) return;
        this.handleSearchInput(url);
      });

    document.addEventListener('fullscreenchange', () => {
      if (document.fullscreenElement) {
        // fullscreen is activated
        this.inFullscreen = true;
      } else {
        // fullscreen is cancelled
        this.inFullscreen = false;
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        // focus to the input with Angular
        $('.video-url').select();
      }
    });

    let timer_ = null;
    clearInterval(timer_);
    timer_ = setInterval(() => {
      this.bullets = this.ytb.bullets;
    }, 500);

    if (this.searchText) {
      this.search();
    } else {
      this.getPopularVideos();
    }
  }

  handleSearchInput(url: string) {
    this.invalidUrl = false;
    this.ytb.playLink = url;
    this.searchText = '';
    this.searchResults = [];

    const parsed = this.ytb.parseUrl(url.trim());
    if (parsed.playlistId)
      this.ytb.loadPlaylistById(parsed.playlistId, parsed.indexInPlaylist);
    else if (parsed.videoId) {
      this.ytb.loadVideoById(parsed.videoId);
      this.indexInList = -1;
    } else if (url.trim()) {
      this.ytb.playLink = '';
      this.searchText = url;
      this.search();
    } else {
      this.invalidUrl = true;
    }

    this.updateUrlWithVideoInfo(
      parsed.videoId,
      parsed.playlistId,
      this.searchText
    );
  }
  onEnterKey() {
    if (this.videoUrlCtrl.value) {
      this.handleSearchInput(this.videoUrlCtrl.value);
    }
  }

  async getPopularVideos() {
    this.isLoadingPopularVideos = true;
    const popularVideos = await this.socketService.asyncSend(
      'getMostPopularVideos'
    );
    this.suggestions = [...popularVideos, ...suggestions];
    this.isLoadingPopularVideos = false;
  }
  openSuggestion(s) {
    this.indexInList = this.searchResults.length
      ? this.searchResults.indexOf(s)
      : this.suggestions.indexOf(s);
    if (s.playlistId) this.ytb.loadPlaylistById(s.playlistId);
    else if (this.searchResults.length) {
      this.ytb.loadVideoById(s.videoId, {
        startSeconds: s.start,
      });
      this.searchService.setSearchText(this.searchText);
      this.searchService.setSearchResultLanguage(s.languageName);
    } else this.ytb.loadVideoById(s.videoId);
    this.updateUrlWithVideoInfo(s.videoId, s.playlistId, this.searchText);
  }
  openShares() {
    $('app-shares .modal').modal('show');
  }
  async search() {
    this.searchService.setSearchText(this.searchText);
    if (this.searchText) {
      this.isSearching = true;
      this.searchService.setIsSearching(true);
      this.ytb.stopVideo();

      console.log(
        'Searching for: ',
        this.searchText,
        ' voice language: ',
        this.selectedVoiceLanguage
      );
      const searchResults_ = await this.socketService
        .asyncSend('searchCaptions', {
          searchText: this.searchText,
          voiceLanguageCode: this.availableVoiceLanguages.find(
            (l) =>
              l.code === this.selectedVoiceLanguage ||
              l.name === this.selectedVoiceLanguage ||
              l.en === this.selectedVoiceLanguage
          )?.code,
          version: 'v2',
        })
        .catch(console.error);
      if (searchResults_.searchText !== this.searchText) return;
      this.searchResults = searchResults_.data;
      this.indexInList = -1;
      this.isSearching = false;
      this.searchService.setIsSearching(false);

      if (this.searchResults.length) {
        this.indexInList = 0;
        this.ytb.loadVideoById(this.searchResults[0].videoId, {
          startSeconds: this.searchResults[0].start,
        });
        this.updateUrlWithVideoInfo(
          this.searchResults[0].videoId,
          '',
          this.searchText
        );
        this.searchResults.forEach((r) => {
          r.title = `"${this.searchText}" occurs at ${r.start} seconds`;
        });
        this.invalidUrl = false;
      } else {
        this.invalidUrl = true;
      }
    }
    this.searchService.setSearchResultLanguage(
      this.searchResults[0]?.languageName || ''
    );
  }
  updateUrlWithVideoInfo(videoId, playlistId, search) {
    const searchParams = {
      v: videoId,
      list: playlistId,
      search: search,
      voice: this.selectedVoiceLanguage,
    };
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: searchParams,
      queryParamsHandling: 'merge',
    });

    function updateTopWindowUrl() {
      // Ensure window.top is accessible
      const url = new URL(window.top.location.href);

      // Update the URL parameters
      url.searchParams.set('v', videoId);
      if (playlistId) url.searchParams.set('list', playlistId);
      else url.searchParams.delete('list');
      if (search) url.searchParams.set('search', search);
      else url.searchParams.delete('search');
      if (searchParams.voice) url.searchParams.set('voice', searchParams.voice);
      else url.searchParams.delete('voice');
      url.searchParams.delete('link');

      // Use history.replaceState to update the URL without refreshing the page
      window.top.history.replaceState({}, '', url.toString());
    }

    if (window.top != window.self && window.top?.location) {
      updateTopWindowUrl();
    }
  }
  isSmallScreen() {
    return window.innerWidth < 768;
  }
  onVoiceLanguageChange({ en }: { en: string }) {
    // Call your search function here, passing the selected language code if needed
    console.log('Selected voice language:', en);
    this.selectedVoiceLanguage = en || '';
    localStorage.setItem('selectedVoiceLanguage', en);
    this.search();
  }
}
